// extracted by mini-css-extract-plugin
export var boxItems = "_1x-1";
export var boxItemsLg = "_1x-2";
export var button = "_1x-7";
export var buttonLg = "_1x-8";
export var filterGroupBox = "_1x-0";
export var icon = "_1x-3";
export var iconSecondary = "_1x-6";
export var iconWrapper = "_1x-4";
export var iconWrapperLg = "_1x-5";